<template>
  <div class="conainer">
        <h1>Privacy Policy</h1>
        <p>
            At CryptoSlots, your privacy is our top priority. This app does not collect, store, or share any personal data about its users. We do not track your location, access your contacts, or collect any information from your device.
        </p>
        <p>
            The app operates independently without requiring any personal information. Any data you use within the app, such as chips or Ethereum transactions, is handled locally on your device and is not shared with third parties.
        </p>
        <p>
            If you have any questions or concerns about this privacy policy, feel free to contact us at support@cryptoslots.com.
        </p>
        <p>
            Thank you for choosing CryptoSlots. Enjoy a secure and private gaming experience!
        </p>
    </div>
</template>

   <style>
        body {
            font-family: Arial, sans-serif;
            line-height: 1.6;
            margin: 0;
            padding: 0;
        }
        .container {
            max-width: 800px;
            margin: 20px auto;
            padding: 20px;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
            border-radius: 8px;
            background-color: #f9f9f9;
        }
        h1 {
            font-size: 2em;
            color: #333;
        }
        p {
            color: #555;
        }
    </style>
